import { Box } from "@mui/material";
import React from "react";
import ActivityLogSearch from "./src/activityLogSearch";
import ActivityLogFilters from "./src/activityLogFilters";
import ActivityLogTable from "./src/activityLogTable";

const ActivityLogContainer = (): React.JSX.Element => (
  <Box sx={{ py: 4 }}>
    <ActivityLogSearch />
    <ActivityLogFilters />
    <ActivityLogTable />
  </Box>
);

export default ActivityLogContainer;
